import type { RootState } from "../../../../Application/globaltypes/redux";
import { createSelector } from "@reduxjs/toolkit";

export const selectStates = (state: RootState) => state.packs.payment.states.states;
export const selectStatesError = (state: RootState) => state.packs.payment.states.error;
export const selectStateMapping = createSelector([selectStates], (states) =>
  states.reduce(
    (acc, state) => {
      acc[state.abbreviation] = state.name;
      return acc;
    },
    {} as Record<string, string>,
  ),
);

export const selectPurchasePrice = (state: RootState) => state.packs.payment.purchasePrice;
export const selectPurchasePriceError = (state: RootState) => state.packs.payment.purchasePrice.error;

export const selectPaymentStatus = (state: RootState) => state.packs.payment.processing.status;
export const selectPaymentError = (state: RootState) => state.packs.payment.processing.error;
